import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export const useRevalidateOnLanguageChange = (formik) => {
  const { i18n } = useTranslation();
  const formikRef = useRef();

  useEffect(() => {
    const handleLanguageChange = () => {
      setTimeout(() => {
        const fromInstance = formik || formikRef.current;
        if (fromInstance) {
          const currentValues = { ...fromInstance.values };
          const currentTouched = { ...fromInstance.touched };
          fromInstance.validateForm(currentValues).then((errors) => {
            const touchedErrors = Object.keys(errors).reduce((acc, field) => {
              if (currentTouched[field]) {
                acc[field] = errors[field];
              }
              return acc;
            }, {});
            fromInstance.setErrors(touchedErrors);
            fromInstance.setTouched(currentTouched);
            fromInstance.setValues(currentValues);
          });
        }
      });
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n, formik]);
  return { formikRef };
};
